import React from 'react';
import './ShippingPolicy.css';
import { ProfileBG } from '../../Assests/Assests';

const PrivacyPolicy = () => {
  return (





<div className="shipping-policy-container">
      <div className="image-container">
        {/* <img src={ProfileBG} alt="Shipping Bag" className="bag-image" /> */}
        <div className="image-text">Privacy Policy</div>
      </div>
      <div className="shipping-text">
     







        <p>
          At Riymay, we prioritize the privacy of our customers and are fully committed to ensuring that all personal data shared with us is handled with the highest standards of security and confidentiality.
        </p>
        <p>
          When you interact with our website, make a purchase, or contact our support team, we may collect certain personal details such as your name, email address, phone number, shipping and billing addresses, and payment information.
        </p>
        <p>
          These details allow us to process orders efficiently, provide seamless customer support, and enhance your overall shopping experience.
        </p>
        <p>
          Additionally, we use tracking technologies to better understand user behavior, optimize our website’s performance, and tailor our services to meet your needs.
        </p>
        <p>
          While we do not use cookies for tracking, we rely on advanced tracking technologies for analytics and marketing purposes through third-party tools such as Google Analytics, Meta Pixel, and other similar platforms.
        </p>
        <p>
          Your information is sometimes shared with our shipping partners to ensure timely deliveries and with payment processors to facilitate secure transactions; however, we do not sell your data to third parties under any circumstances.
        </p>
        <p>
          Our customers have the right to request access to, correct, or delete their personal data, but at this moment, we do not offer an opt-out option for marketing emails or tracking.
        </p>
        <p>
          We implement strict security measures to safeguard all customer data, though we cannot guarantee absolute security but strive to offer the best protection possible.
        </p>
        <p>
          Our data processing and storage are conducted in India, and we comply with local data protection regulations.
        </p>
        <p>
          For customers accessing our website from outside India, please be aware that your data may be transferred and stored in a jurisdiction different from your own.
        </p>
        <p>
          Riymay’s website and products are designed for all age groups, but we do not knowingly collect or store data from children under the age of 13.
        </p>
        <p>
          If such information is inadvertently collected, we will take immediate action to delete it.
        </p>
        <p>
          Our Privacy Policy is subject to periodic updates, and any significant changes will be communicated to our customers via email.
        </p>
        <p>
          If you have any privacy-related concerns, inquiries, or requests regarding your personal data, please contact our support team at <strong>support@riymay.com</strong>.
        </p>
        <p>
          We appreciate your trust in Riymay and remain dedicated to providing a secure and transparent shopping experience.
        </p>
       
      </div>
    </div>
  );
};

export default PrivacyPolicy;
